import SaveIcon from '@mui/icons-material/Save';
import { LoadingButton } from '@mui/lab';
import { Accordion, AccordionDetails, AccordionSummary, Box, Card, CardContent, CardHeader, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, IconButton, InputLabel, ListItemText, MenuItem, Radio, RadioGroup, Select, Table, TableBody, TableCell, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import { makeStyles, styled } from '@mui/styles';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { AuthStore } from '../../../../store/UserStore';
import { base_url } from '../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../utils/MyEncryption';
import { ArrowBack, ExpandMore } from '@mui/icons-material';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { updateFirebasePencairan } from '../../../../utils/Firebase';

const useStyles = makeStyles({
    root: {
        position: "sticky",
        top: "5rem",
        minWidth: "275"
    }
});

const Item = styled(Card)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    // padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    // overflowY: "scroll"
}));

const FormSpm = () => {
    const { setBreadcrumbItem } = useOutletContext();
    const classes = useStyles()
    const location = useLocation();
    const navigate = useNavigate();
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const logOut = AuthStore((state) => state.logOut);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState([]);
    const [listDokumen, setListDokumen] = useState([]);
    const [listBud, setListBud] = useState([]);
    const pencairan = location.state || null;
    const [formData, setFormData] = useState({
        tgl_spm: "",
        no_spm: "",
        no_spp: "",
        jenis: "",
        jenis_ls: "",
        keperluan: "",
        anggaran: "",
        accept: "",
        bud: "",
        id_opd: "",
        nm_opd: "",
        kontrak: "",
        revisi: null,
        revisi_sebelumnya: null
    });

    useEffect(() => {
        console.log(pencairan);
        setBreadcrumbItem({ '/verif': 'Home', '/verif/spm': 'Pencairan', '': 'Periksa' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setFormData({
            ...formData,
            tgl_spm: pencairan.tgl_spm,
            no_spm: pencairan.no_spm,
            no_spp: pencairan.no_spp,
            jenis: pencairan.jenis,
            jenis_ls: pencairan.jenis_ls,
            keperluan: pencairan.keperluan,
            anggaran: rP(pencairan.anggaran),
            revisi: null,
            revisi_sebelumnya: pencairan.revisi,
            id_opd: pencairan.id_opd,
            nm_opd: pencairan.nm_opd
        });

        axios.get(
            base_url + '/kelengkapans',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setListDokumen(response.data.kelengkapans)
                console.log(response);
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
            })

        axios.get(base_url + '/get-bud')
            .then((response) => {
                setListBud(response.data)
                console.log(listBud);
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const submitForm = () => {
        console.log(listDokumen);
        const post = {
            _method: 'PUT',
            no_spm: pencairan.no_spm
        }

        if (formData.accept === "ya") {
            if (selected.length === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Ceklis Kelengkapan Dokumen!!'
                })
                return
            }
            post.progres = 3
            post.revisi = null
            post.kelengkapan = selected.toString();
            if (formData.bud === "") {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Pilih BUD atau Kuasa BUD!!'
                })
                return
            }
            post.bud = formData.bud;
            console.log(post);
        }
        else if (formData.accept === "tidak") {
            post.progres = 2
            if (formData.revisi === null || formData.revisi === "") {
                post.revisi = null;
            }
            else {
                post.revisi = formData.revisi;
            }
        }
        else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Setujui atau Tolak Dahulu'
            })
            return
        }

        setLoading(true);
        axios.post(
            base_url + '/verif/pencairan/update',
            post,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })

                updateFirebasePencairan(formData, post.progres)

                setFormData({
                    tgl_spm: "",
                    no_spm: "",
                    no_spp: "",
                    jenis: "",
                    keperluan: "",
                    anggaran: "",
                    file: "",
                    revisi: null,
                    revisi_sebelumnya: null,
                    accept: "",
                    bud: "",
                    nm_opd: ""
                });
                setLoading(false);
                navigate(-1);
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setLoading(false);
            })

        setLoading(false);
    }

    const handleSelect = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handleNoteChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    const handleCheckBox = (e) => {
        console.log(e.target.value);
        if (e.target.checked) {
            setSelected([
                ...selected,
                e.target.value,
            ]);
        } else {
            // remove from list
            setSelected(
                selected.filter((xxx) => xxx !== e.target.value),
            );
        }
        console.log(selected);
    }

    return (
        <Box fixed>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Card>
                        <CardHeader
                            title={
                                <Typography variant='h5'>Verifikasi Dokumen</Typography>
                            }
                            avatar={
                                <Tooltip title="Kembali">
                                    <IconButton variant="outlined" onClick={() => {
                                        navigate(-1)
                                    }} color="error"><ArrowBack /></IconButton>
                                </Tooltip>
                            }
                        // subheader="September 14, 2016"
                        />
                        <CardContent>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            <ListItemText primary="No. SPM" secondary={pencairan.no_spm} />
                                        </TableCell>
                                        <TableCell>
                                            <ListItemText primary="No. SPP" secondary={pencairan.no_spp} />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <ListItemText primary="Tanggal SPM" secondary={pencairan.tgl_spm} />
                                        </TableCell>
                                        <TableCell>
                                            <ListItemText primary="Jenis Pencairan" secondary={pencairan.jenis + " " + pencairan.jenis_ls} />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <ListItemText primary="Keperluan" secondary={pencairan.keperluan} />
                                        </TableCell>
                                        <TableCell>
                                            <ListItemText primary="Anggaran" secondary={"Rp " + rP(pencairan.anggaran)} />
                                        </TableCell>
                                    </TableRow>
                                    {
                                        pencairan.revisi !== null &&
                                        <TableRow>
                                            <TableCell colSpan={2}>
                                                <ListItemText primary={<Typography color="error">Revisi Sebelumnya</Typography>} secondary={pencairan.revisi} />
                                            </TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Grid container spacing={2} py={2} justifyContent="center">
                <Grid item xs={12} md={3}>
                    <Item className={classes.root}>
                        <CardHeader
                            title="Penelitian Kelengkapan Dokumen"
                        />
                        <CardContent sx={{ maxHeight: 600, minHeight: 450, overflowY: "scroll", mb: 2 }}>
                            {/* <CardContent> */}
                            <FormGroup>
                                {
                                    listDokumen.map((item, index) => (
                                        <FormControlLabel key={index} control={
                                            <Checkbox
                                                value={item.kelengkapan}
                                                onChange={handleCheckBox}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />
                                        } label={item.kelengkapan} />
                                    ))
                                }
                            </FormGroup>
                        </CardContent>
                    </Item>
                </Grid>
                {/* file_spm: base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/ls/spm/' + pencairan.file, */}

                <Grid item xs={12} md={9} sx={{ textAlign: "center" }}>
                    <Grid container spacing={2}>
                        <Grid item lg={12}>
                            <Accordion>
                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                    <Typography>File SPM</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <iframe allowFullScreen width='100%' height={700} title="Pdf" src={
                                        base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/' + pencairan.jenis + '/spm/' + pencairan.file
                                    } />
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        {
                            formData.jenis === "LS" && formData.jenis_ls === "Modal" &&
                            <>
                                <Grid item lg={12}>
                                    <Accordion>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                            <Typography>File Kontrak / Adendum</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={
                                                base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/kontrak/' + pencairan.kontrak + '.pdf'
                                            } />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                                <Grid item lg={12}>
                                    <Accordion>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                            <Typography>File Dokumentasi</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={
                                                base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/' + pencairan.jenis + '/dokumentasi/' + pencairan.file
                                            } />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                                <Grid item lg={12}>
                                    <Accordion>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                            <Typography>File Progres</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={
                                                base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/' + pencairan.jenis + '/progres/' + pencairan.file
                                            } />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                                <Grid item lg={12}>
                                    <Accordion>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                            <Typography>File Berita Acara</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={
                                                base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/' + pencairan.jenis + '/berita_acara/' + pencairan.file
                                            } />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </>
                        }
                        {
                            formData.jenis === "GU" &&
                            <Grid item lg={12}>
                                <Accordion>
                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                        <Typography>File SPJ Fungsional</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <iframe width='100%' height={700} title="Pdf" src={
                                            base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/' + pencairan.jenis + '/spj_fungsional/' + pencairan.file
                                        } />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        }
                        {
                            formData.jenis === "LS" && formData.jenis_ls === "Gaji" &&
                            <>
                                <Grid item lg={12}>
                                    <Accordion>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                            <Typography>File Daftar Gaji</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={
                                                base_url + '/uploads/' + pencairan.tahun_anggaran + '/' + pencairan.id_opd + '/' + pencairan.jenis + '/daftar_gaji/' + pencairan.file
                                            } />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </>
                        }
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={2} py={2} justifyContent="center">
                <Grid item xs={12} textAlign={'center'}>
                    <FormControl>
                        <FormLabel id="demo-row-radio-buttons-group-label">Setujui?</FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            // name="row-radio-buttons-group"
                            name="accept"
                            value={formData.accept}
                            onChange={handleSelect}
                        >
                            <FormControlLabel value="ya" control={<Radio />} label="YA" />
                            <FormControlLabel value="tidak" control={<Radio color="error" />} label="TIDAK" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                {formData.accept === 'tidak' &&
                    <Grid item xs={12} md={8}>
                        <TextField
                            id="filled-multiline-static"
                            label="Catatan Revisi"
                            multiline
                            fullWidth
                            rows={4}
                            // variant="standard"
                            name="revisi"
                            defaultValue={formData.revisi}
                            onChange={handleNoteChange}
                        />
                    </Grid>
                }
                {formData.accept === 'ya' &&
                    <Grid item xs={12} md={6}>
                        <FormControl variant="standard" fullWidth sx={{ m: 1, minWidth: 120 }}>
                            <InputLabel id="demo-simple-select-standard-label">BUD / Kuasa BUD</InputLabel>
                            <Select
                                name='bud'
                                fullWidth
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={formData.bud}
                                onChange={handleSelect}
                                label="Age"
                            >
                                {
                                    listBud.map((item) => (
                                        <MenuItem key={item.nip} value={item.nip}>{item.nama}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                }
            </Grid>

            <Grid container spacing={2} justifyContent="flex-end">
                <Grid item>
                    <Grid container spacing={2}>
                        <Grid item>
                            <LoadingButton
                                onClick={submitForm}
                                loading={loading}
                                variant="contained"
                                margin="normal"
                                loadingPosition="start"
                                startIcon={<SaveIcon />}
                            >
                                Simpan
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}

export default FormSpm